import { format, formatRelative, isSameDay, isYesterday, parseISO } from "date-fns";
import { it } from "date-fns/locale";

export function formatDateFromNow(date: Date) {
  if (isSameDay(date, new Date())) return "Oggi";
  else if (isYesterday(date)) return "Ieri";
  else {
    return format(date, "E dd/LL", { locale: it });
  }
}

export function formatTime(date: Date, seconds = false) {
  return format(date, "HH:mm" + (seconds ? ":ss" : ""), { locale: it });
}

export function formatExtendedDate(date: Date) {
  // domenica 01 gennaio 2022
  return format(date, "eeee dd LLLL y", { locale: it });
}

export function formatDate(date: Date | string, formatString?: string) {
  const d = typeof date === "string" ? parseISO(date) : date;
  if (formatString) return format(d, formatString, { locale: it });
  return format(d, "dd/MM/y", { locale: it });
}

export function formatDateTime(date: Date, formatString?: string) {
  if (formatString) return format(date, formatString, { locale: it });

  return (
    format(date, "dd/MM/y", { locale: it }) +
    " " +
    format(date, "HH:mm:ss", { locale: it })
  );
}

export function getNightsBetweenDates(startDate: Date, endDate: Date): number {
  const start = new Date(startDate);
  const end = new Date(endDate);
  // Set the time to midnight to avoid partial days
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  // Calculate the difference in milliseconds and convert to nights
  return Math.ceil((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
}

export function getDaysBetweenDates(startDate: Date, endDate: Date): number {
  const start = new Date(startDate);
  const end = new Date(endDate);
  // Set the time to midnight to avoid partial days
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  // Calculate the difference in milliseconds and convert to days
  return (
    Math.ceil((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)) + 1
  ); // Add 1 to include the start day
}

export function formatRelativeToNow(date: Date) {
  return formatRelative(date, new Date(), { locale: it });
}

export function toLocalDateString(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}
